
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const striker: Operator = {
	id: 'striker',
	name: 'Striker',
	role: 'Attacker',
	org: 'ROS',
	squad: 'none',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 1
	},
	meta: {
		gender: 'u',
		country: 'none',
		season: 'Y9S2',
		height: 0,
		weight: 0,
		price: {
			renown: 25000,
			r6credits: 600
		}
	},
	bio: {
		real_name: 'Undefined',
		birthplace: 'Undefined'
	},
	svg: {
		contents: '<defs><mask id="striker-__a"><path fill="#fff" d="M0 0h350v350H0z"></path><path d="M115 73c31-15 84-16 118 2l11 9 3 13c-43-31-102-32-145-4l1-12Zm-25 55c55 8 111 9 165 0l1 14c-55 7-112 6-168-1Zm15 34h135v26c0 15-17 36-39 39-4-10-16-16-26-20-10 4-22 10-26 20-22-3-39-24-44-39Zm133 81-40 5v4l41-4Z"></path><path d="M181 250q0-7 7-7h5q7 0 7 7t-7 7h-5q-7 0-7-7M148 51c-17 39-23 71-23 112l4 55c0 21 0 26 6 35 3 6 5 14 6 22 0-8-2-16-5-23-5-9-5-13-5-33l-4-56c0-42 6-72 23-112Zm54 1c17 39 23 71 23 112l-1 52c0 21 0 26-6 35-3 6-5 14-6 19 0-5 2-13 5-20 5-9 5-13 5-33l1-53c0-42-6-72-23-112Z"></path></mask></defs><path d="M45 45h260v260H45z" opacity=".4"></path><path d="M71 71h208v97l-28-2 28 8v27l-54 3 54 5v70H71V179l40-19-40 10Z"></path><path fill="#ff8e2d" d="m54 117-6-13 1-4h9l3 3 5-1 5 5h4l5 5 14 5-5 37-52-23 1-3 11 3-9-6 6-14Zm3-75 13 8 16 20 5-7 20 15-14 20-9-3 7 7-3 10-9-4-8-7-6-6-9-3-7-2-5-6-10-4 5-10 4 1-3-5 3-5 13 6-12-11Zm171 25 11-14h17l-5 6 10-4 4 4-27 22Zm12 15 41-30 10-2-6 8 16-10 6 4 2 4-23 16 21-8 9 15-10 9 10-4 1 1 1 3-64 39-8-36 12-5-13 2Zm15 49 46-25 2 9-16 7 16-3 2 10 1 7 1 4-6 2h-6l-5 4h-8l-4 1h-6l-14 11 1-15 13-6-14 2Zm-9 78 34 14 15 4 20 9-3 6-15-5 10 10-5 4-3 5-1 4-27-10 23 14v4l-2 4h-10l-21-14-36-11 8-22 24 10-8-9-12-4Zm1 49 9 3 56 35-7 2-4 1-2 3-18-7 3 5-4 1-5 4-3-4-7 1-1-2-25-16Zm-139 26-9 11-15 8-16 8 9-22-8 9-6 1-5 1-1 1h-5l-1-3 6-8-6 2-2-3-1-7 26-18 29-17-2 21-18 9 18-4Zm2-47-18 6-12 9-6 7H61l-3-8 17-11-19 8-9-15-9-12 17-2 17-12 31-11Z"></path><path d="M175 43c56 1 83 45 85 86 10 48 5 68-18 102v10c13 3 13 31 2 47-8 10-37 19-69 20-32-1-61-10-70-19-13-9-13-44-1-48v-11c-18-33-28-48-18-102 5-41 28-84 89-85"></path><path fill="#fff" d="M175 48c49 0 78 43 80 94 7 39 3 53-18 85v16c0 11-41 43-60 43l-2 20-2-20c-25-1-65-31-66-43v-17c-20-33-22-53-18-85 6-43 27-93 86-93" mask="url(#striker-__a)"></path><path fill="#fff" d="M168 304c-24-3-48-10-63-20-7-13-8-25-1-35 9 14 39 35 63 41Zm14 0c23-3 47-10 58-20 7-7 9-28 2-35-8 13-38 35-59 41Z"></path>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-striker'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
